<template>
  <div>
    <v-tour
      v-if="steps.length"
      name="myTour"
      :steps="steps"
      :callbacks="myCallbacks"
      :options="options"
    >
      <template v-slot:default="tour">
        <transition name="fade">
          <v-step
            v-if="tour.steps[tour.currentStep]"
            :key="tour.currentStep"
            :step="tour.steps[tour.currentStep]"
            :previous-step="tour.previousStep"
            :next-step="tour.nextStep"
            :stop="tour.stop"
            :skip="tour.skip"
            :is-first="tour.isFirst"
            :is-last="tour.isLast"
            :labels="tour.labels"
            :enabled-buttons="tour.enabledButtons"
            class="pa-5 d-flex flex-column"
            style="background-color: #33B6B0; width: 410px; row-gap: 20px; max-width: 90vw;"
          >
            <template>
              <div slot="header" class="font-weight-medium">
                <div v-html="tour.steps[tour.currentStep].title"/>
                <hr class="white mt-5">
              </div>
              <div slot="content" class="text-body-2" v-html="tour.steps[tour.currentStep].content"/>
              <div slot="actions" class="d-flex justify-center" style="column-gap: 4px;">
                <v-btn
                  v-if="!tour.isLast && isButtonEnabled('buttonSkip')"
                  class="tiffany-8--text v-step__button-skip"
                  @click.prevent="tour.skip"
                >
                  {{ tour.labels.buttonSkip }}
                </v-btn>
                <v-btn
                  v-if="!tour.isFirst && isButtonEnabled('buttonPrevious')"
                  class="tiffany-8--text v-step__button-previous"
                  @click.prevent="tour.previousStep"
                >
                  {{ tour.labels.buttonPrevious }}
                </v-btn>
                <v-btn
                  v-if="!tour.isLast && isButtonEnabled('buttonNext')"
                  class="tiffany-8--text v-step__button-next"
                  @click.prevent="tour.nextStep"
                >
                  {{ tour.labels.buttonNext }}
                  <template v-if="options.showStepsOnBtn">
                    {{ `(${tour.currentStep+1}/${tour.steps.length})` }}
                  </template>
                </v-btn>
                <v-btn
                  v-if="tour.isLast && isButtonEnabled('buttonStop')"
                  class="tiffany-8--text v-step__button-stop"
                  @click.prevent="tour.finish"
                >
                  {{ tour.labels.buttonStop }}
                  <template v-if="options.showStepsOnBtn">
                    {{ `(${tour.currentStep+1}/${tour.steps.length})` }}
                  </template>
                </v-btn>
              </div>
            </template>
          </v-step>
        </transition>
      </template>
    </v-tour>
    <div v-if="showOverlay" class="tour-overlay"></div>
  </div>
</template>

<script>
import { DEFAULT_OPTIONS } from "vue-tour/src/shared/constants";

export default {
  name: 'TourWidget',

  data() {
    return {
      steps: [],
      currentTourCompleteHandler: null,
      showOverlay: false,
      highlightedElement: null,
      highlightedBgColor: null,
      myCallbacks: {
        onNextStep: this.myCustomNextCallback,
        onStart: this.onStart,
        onStop: this.onTourStop,
        onSkip: this.onTourStop
      },
      options: {}
    }
  },

  created() {
    this.$tourManager.register(this)
  },

  methods: {
    isButtonEnabled(name) {
      return this.options.enabledButtons.hasOwnProperty(name) ? this.options.enabledButtons[name] : true
    },
    toggleShowOverlay() {
      this.showOverlay = true
    },
    setHighlight(selector, highlightBgColor) {
      console.log(selector)
      // console.log(this.highlightedBgColor)
      // if (this.highlightedElement) {
      //   this.highlightedElement.classList.remove('tour-highlight')
      //   this.highlightedElement.style.backgroundColor = this.highlightedBgColor
      // }

      const el = document.querySelector(selector)
      if (el) {
        el.classList.add('tour-highlight')
        this.highlightedBgColor = el.style.backgroundColor
        if (highlightBgColor) {
          el.style.backgroundColor = highlightBgColor
        }
        this.highlightedElement = el
      }
    },
    clearHighlight(selector) {
      if (this.highlightedElement) {
        this.highlightedElement.classList.remove('tour-highlight')
        this.highlightedElement.style.backgroundColor = this.highlightedBgColor
        this.highlightedElement = null
        this.highlightedBgColor = null
      }
    },
    runAnAfter () {
      const step = this.steps[this.$tours['myTour'].currentStep]
      if( step.after ){
        step.after();
      }
    },
    myCustomNextCallback(currentStep) {
      this.runAnAfter()
      // this.clearHighlight(currentStep)

      const nextStep = this.steps[currentStep + 1]
      if (nextStep?.route) {
        this.$router.push(nextStep.route).then(() => {
          this.$nextTick(() => {
            // this.setHighlight(nextStep.target, nextStep.highlightBgColor)
          })
        }).catch(() => {
          this.$nextTick(() => {
            // this.setHighlight(nextStep.target, nextStep.highlightBgColor)
          })
        }).finally(() => {
        })
      } else {
        // this.setHighlight(nextStep?.target, nextStep?.highlightBgColor)
      }
    },
    onStart() {
      // this.toggleShowOverlay()
      document.body.classList.add('tour-active')
    },
    async onTourStop() {
      this.runAnAfter()
      this.showOverlay = false
      this.clearHighlight()
      if (typeof this.currentTourCompleteHandler === 'function') {
        await this.currentTourCompleteHandler()
      }
      this.$store.commit('tour/stopTour')
      document.body.classList.remove('tour-active')
    },
    startTour(tourModule) {
      this.steps = tourModule.steps
      this.options = tourModule.options || DEFAULT_OPTIONS
      this.currentTourCompleteHandler = () => tourModule.onComplete()
      this.$store.commit('tour/startTour', tourModule.id)
      this.$nextTick(() => {
        this.$tours['myTour'].start()
      })
    }
  }
};
</script>

<style lang="scss">
.tour-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 100;
  pointer-events: none;
}

.tour-highlight {
  position: relative;
  z-index: 999;
  //background-color: #ffffff; /* 或 #f9f9f9、#fafafa，看你的 UI */
  box-shadow: 0 0 0 4px white;
}

/* 禁用全站點擊 */
body.tour-active * {
  pointer-events: none !important;
}

/* 導覽 tooltip 可互動 */
body.tour-active .v-tour,
body.tour-active .v-tour * {
  pointer-events: auto !important;
}
</style>
